import { useUpdated } from "@common/lib/hooks";
import classNames from "classnames";
import * as React from "react";

export type Props = {
  ref?: (node: HTMLElement | null) => void;
  className?: string;
  isCollapsed: boolean;
  isLazy?: boolean; // TODO: implement
  noAnimation?: boolean;
  children?: any;
  style?: React.CSSProperties;
};

const Collapsible = (props: Props) => {
  const ref = React.useRef<HTMLInputElement>(null);

  React.useImperativeHandle(props.ref, () => ref.current as HTMLInputElement);

  React.useEffect(() => {
    if (props.isCollapsed) {
      $(ref.current!).slideUp(0);
    }
  }, []);

  useUpdated(() => {
    if (props.isCollapsed) {
      $(ref.current!).slideUp(props.noAnimation ? 0 : 250);
    } else {
      $(ref.current!).slideDown(props.noAnimation ? 0 : 250);
    }
  }, [props.isCollapsed]);

  return (
    <div ref={ref} className={classNames(props.className, "collapsible")} style={props.style}>
      {props.children}
    </div>
  );
};

export default Collapsible;
